import { Box, Text, Flex } from '@chakra-ui/react';
import { HiOutlinePlusSmall } from 'react-icons/hi2';
import { MdAlternateEmail } from 'react-icons/md';
import { FiPhoneCall } from 'react-icons/fi';

import { useSelector } from 'react-redux';

import ContactItem from './ContactItem';

const phoneList = [
  { id: 1, phoneNumber: '+1(123)456-7890', phoneType: 'COMPANY' },
  { id: 1, phoneNumber: '+1(123)456-7891', phoneType: 'PERSONAL' },
];

const MobileInfo = () => {
  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);

  if (activeProspect?.phoneInfo)
    return (
      <Box>
        <Flex justifyContent="space-between" px={3} pb={3}>
          <Text fontSize={12} fontWeight={600} color="orange.primary">
            PHONE
          </Text>
          <Text color="orange.primary" fontSize={18}>
            <HiOutlinePlusSmall />
          </Text>
        </Flex>
        {activeProspect?.phoneInfo.length > 0 &&
          activeProspect?.phoneInfo.map((item, index) => (
            <ContactItem
              key={index}
              icon={<FiPhoneCall />}
              phoneNumber={item.phoneNumber || 'No Phone'}
              phoneType={item.phoneType}
              type="phone"
            />
          ))}
      </Box>
    );
};
export default MobileInfo;
